export class AdditionalFieldData {
  id: string;
  values: any[] = [];
  type: string;

  selectOtherField: any | undefined;

  static readonly SENTINAL_NULL_VALUE = "\u0000";

  constructor(id?: string, type?: string) {
    this.id = id ?? '';
    this.type = type ?? '';
  }

  public static createFromJson(input: any): AdditionalFieldData {
    const data = new AdditionalFieldData();
    data.fromJson(input);
    return data;
  }

  get hasSentinalValue(): boolean {
    return this.values.includes(AdditionalFieldData.SENTINAL_NULL_VALUE);
  }

  fromJson(input: any) {
    this.id = input["id"];
    if (input["values"]) {
      for (const child of input["values"]) {
        this.values.push(child);
      }
    }
    this.type = input["type"];
  }

  toJson(): any {
    const returnValues = this.values.filter(value => value != AdditionalFieldData.SENTINAL_NULL_VALUE)
    if (this.selectOtherField && this.hasSentinalValue) {
      returnValues.push(this.selectOtherField);
    }
    return {
      "id": this.id,
      "values": returnValues,
      "type": this.type
    }
  }
}
